export class VehicleEmission {
    constructor(vehicleId, latitude, longitude, emissionValue, timestamp) {
        this.vehicleId = vehicleId;
        this.latitude = latitude;
        this.longitude = longitude;
        this.emissionValue = emissionValue;
        this.timestamp = new Date(timestamp);
    }
}